import { Box, Text } from '@wix/design-system';
import { MediaDevices } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { useBreakpoint } from 'providers/BreakpointProvider';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CardBrands } from 'src/constants';
import { getPaymentMethodsFromDealerOffers } from 'utils';
import { AcceptedPaymentMethodIcons } from './AcceptedPaymentMethodIcons';

export interface AcceptedPaymentMethodsProps {
  rootStore: RootStore;
}

const AcceptedPaymentMethodsComp: React.FunctionComponent<
  AcceptedPaymentMethodsProps
> = ({ rootStore }) => {
  const { t } = useTranslation();
  const { currentBreakpoint } = useBreakpoint();
  const isMobile = currentBreakpoint === MediaDevices.Mobile;
  const { parsedDealerOffers } = rootStore.appStore.appContext;
  const paymentMethods = getPaymentMethodsFromDealerOffers(
    parsedDealerOffers,
  ) as CardBrands[];

  return (
    <Box direction='vertical' align={isMobile ? 'center' : 'left'}>
      <Text weight='bold' size='tiny' tagName='p'>
        {t('page_footer.accepted_payment_methods')}
      </Text>
      <Box
        direction='horizontal'
        align={isMobile ? 'center' : 'left'}
        gap='10px'
        marginTop='10px'
      >
        <AcceptedPaymentMethodIcons paymentMethods={paymentMethods} />
      </Box>
    </Box>
  );
};

export const AcceptedPaymentMethods = withInjectedRootStore(
  AcceptedPaymentMethodsComp,
);
